import SvgIcon from '@mui/material/SvgIcon';
import * as React from 'react';
const SvgAngleUp = (props)=>/*#__PURE__*/ React.createElement(SvgIcon, {
        ...props,
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "m6.65 13.717 4.826-4.472A.7.7 0 0 1 12 9.014c.187 0 .377.068.524.205l4.825 4.472c.306.285.319.76.03 1.06a.77.77 0 0 1-1.077.03L12 10.768 7.698 14.78a.77.77 0 0 1-1.077-.029c-.289-.271-.276-.746.03-1.034"
    }));
export default SvgAngleUp;
